<div class="commonBody background">
  <br />
  <div fxLayout="row">
    <div fxLayout="column" fxFlex="5"></div>
    <div fxLayout="column" fxFlex="90" fxLayoutAlign="center center">
      <h2><b>Bloom Settings</b></h2>
    </div>
    <div fxLayout="column" fxFlex="5"></div>
  </div>

  <div fxLayout="row">
    <div fxLayout="column" fxFlex="5"></div>
    <div fxLayout="column" fxFlex="90">
      <mat-card>
        <mat-card-content>
          <h3>Toolbar Settings</h3>
          
          <div fxLayout="column" fxLayoutGap="15px">
            <div>
              <label class="settings-label">Menu Location:</label>
              <mat-radio-group [(ngModel)]="menuDisplayType" fxLayout="column" fxLayoutGap="10px">
                <mat-radio-button value="toolbar">Toolbar (Default)</mat-radio-button>
                <mat-radio-button value="sidebar">Sidebar</mat-radio-button>
              </mat-radio-group>
            </div>

            <mat-divider></mat-divider>

            <div>
              <mat-checkbox [(ngModel)]="isFloatingToolbar">Floating Toolbar</mat-checkbox>
              <div class="hint-text">When enabled, the toolbar will float as you scroll down the page</div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div fxLayout="column" fxFlex="5"></div>
  </div>

  <div fxLayout="row" fxLayoutAlign="end center">
    <button mat-stroked-button (click)="cancel()" class="cancel-button">Cancel</button>
    <button mat-raised-button color="primary" (click)="saveSettings()">Save Settings</button>
  </div>
</div>